import { useContext, createContext } from 'react';

export const LevelUpSidePanelInitialState = {
  isOpen: false,

  // need for dropdowns
  levelUpTargetDates: [],
  levelUpProgressStatuses: [],

  // following keys are used to make api calls
  reporteeId: null,
  competencyId: null,
  levelUpId: null,
  levelUpCompetencyId: null,
  isLoggedInEmployeeManager: false,

  // for action items
  checkInInstanceId: null,
  checkInParentId: null,
  filterEmpIds: [],

  // the object that we get after details api call.
  levelUpCompetencyDetails: {},

  // closed count for side panel. we are using this to run effect whenever side panel is closed.
  closedCount: 0,
};

export const LevelUpSidePanelContext = createContext(LevelUpSidePanelInitialState);

export default function useLevelUpSidePanelContext() {
  return useContext(LevelUpSidePanelContext);
}
